import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CompanySettings, Settings } from '../models/settings';
import { License } from '../models/license';
import { first, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private _settings$!: Observable<CompanySettings>;

  constructor(private http: HttpClient) {
    this.reload();
  }

  get(): Observable<CompanySettings> {
    return this._settings$;
  }

  reload(): void {
    this._settings$ = this.http
      .get<CompanySettings>('/api/settings/company')
      .pipe(first())
      .pipe(shareReplay());
  }

  full(): Observable<Settings> {
    return this.http
      .get<Settings>('/api/settings')
      .pipe(first())
      .pipe(shareReplay());
  }

  update(settings: Settings): Observable<Settings> {
    return this.http
      .post<Settings>('/api/settings', settings)
      .pipe(first())
      .pipe(shareReplay());
  }

  license(): Observable<License> {
    return this.http
      .get<License>('/api/licenses')
      .pipe(first())
      .pipe(shareReplay());
  }
}
